import Icon from '../components/Icon.vue'

Icon.register({"lock":{"width":448,"height":512,"paths":[{"d":"M400 224H376V152C376 68.2 307.8 0 224 0S72 68.2 72 152V224H48C21.5 224 0 245.5 0 272V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V272C448 245.5 426.5 224 400 224zM296 224H152V152C152 112.3 184.3 80 224 80S296 112.3 296 152V224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lock.js
// module id = WU6l
// module chunks = 0